import script from "./NewEdictView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewEdictView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__